import { Postcode } from '@dreryk/address-common-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { ValidationRules } from '@dreryk/react-common';

export const CITY_VALIDATION_RULES: ValidationRules<{ city: string | null }> = { required: true, maxLength: 50 };
export const HOUSE_VALIDATION_RULES: ValidationRules<{ house: string | null }> = { required: true, maxLength: 20 };
export const STREET_VALIDATION_RULES: ValidationRules<{ street: string | null }> = { required: false, maxLength: 50 };
export const FLAT_VALIDATION_RULES: ValidationRules<{ flat: string | null }> = {
   maxLength: 10,
};
export const PHONE_NUMBER_VALIDATION_RULES: ValidationRules<{ phoneNumber: PhoneNumber | null }> = {
   required: true,
};
export const POSTCODE_VALIDATION_RULES: ValidationRules<{ postcode: Postcode | null }> = {
   required: true,
};
